/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SetDefaultChargingProfileTask
 */
export interface SetDefaultChargingProfileTask {
    /**
     *
     * @type {number}
     * @memberof SetDefaultChargingProfileTask
     */
    maxChargeKw?: number;
}

/**
 * Check if a given object implements the SetDefaultChargingProfileTask interface.
 */
export function instanceOfSetDefaultChargingProfileTask(
    value: object,
): value is SetDefaultChargingProfileTask {
    return true;
}

export function SetDefaultChargingProfileTaskFromJSON(
    json: any,
): SetDefaultChargingProfileTask {
    return SetDefaultChargingProfileTaskFromJSONTyped(json, false);
}

export function SetDefaultChargingProfileTaskFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): SetDefaultChargingProfileTask {
    if (json == null) {
        return json;
    }
    return {
        maxChargeKw:
            json["maxChargeKw"] == null ? undefined : json["maxChargeKw"],
    };
}

export function SetDefaultChargingProfileTaskToJSON(
    value?: SetDefaultChargingProfileTask | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        maxChargeKw: value["maxChargeKw"],
    };
}
